'use strict';

var _classCallCheck = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/inherits");

var Store = require('orbit-db-store');

var CounterIndex = require('./CounterIndex');

var Counter = require('crdts/src/G-Counter');

var CounterStore =
/*#__PURE__*/
function (_Store) {
  _inherits(CounterStore, _Store);

  function CounterStore(ipfs, id, dbname) {
    var _this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, CounterStore);

    if (!options.Index) Object.assign(options, {
      Index: CounterIndex
    });
    _this = _possibleConstructorReturn(this, _getPrototypeOf(CounterStore).call(this, ipfs, id, dbname, options));
    _this._type = 'counter';
    return _this;
  }

  _createClass(CounterStore, [{
    key: "inc",
    value: function inc(amount) {
      var counter = new Counter(this.uid, Object.assign({}, this._index.get()._counters));
      counter.increment(amount);
      return this._addOperation({
        op: 'COUNTER',
        key: null,
        value: counter.toJSON()
      });
    }
  }, {
    key: "value",
    get: function get() {
      return this._index.get().value;
    }
  }]);

  return CounterStore;
}(Store);

module.exports = CounterStore;